import React from 'react';
import {withRouter} from "react-router-dom";
import CssBaseline from '@material-ui/core/CssBaseline';
import Chip from '@material-ui/core/Chip';
import {Menu, MenuItem} from "@material-ui/core";
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import RadioButtonUncheckedOutlinedIcon from '@material-ui/icons/RadioButtonUncheckedOutlined';
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';
import {AmplifySignOut} from "@aws-amplify/ui-react";

import RequirementTree from "../tree/RequirementTree";
import RequirementDetails from "../card/RequirementDetails";
import TodoLists from "../card/TodoLists";
import UserSettingsDialog from "../user/UserSettingsDialog";

import StylesHappymade from "./StylesHappymade";

import './Requirements.css';

import AddIcon from "@material-ui/icons/AddOutlined";
import Button from "@material-ui/core/Button";

/**
 * props:
 * - product
 * - server
 * - user: A User id (optional)
 */
class Requirements extends React.Component {
    onlyShowMyTasksInDoMode = false;
    hideDoneTasksInPlanMode = false;

    // TODO Use metamodel from the Server.
    metamodel = {
        categories: "categories",
        productChildren: "categories",
        requirementChildren: "categories",
        category : {
            name: "Category",
        },
        requirement : {
            name: "Card",
            values: ["Future", "To do", "Done"],
            initialValues: {
                type: "Card",
                // name: "New card",
                status: "Future",
            },
            labels: {
                "Future": "Future",
                "To do": "Active",
                "Done": "Closed"
            },
            tasks: (parent) => {
                return (parent.cards || parent.tasks || parent.children || []).filter(child =>
                    child.type === 'Task' && this.metamodel.task.visible(child)
                );
            },
        },
        task: {
            name: "Task",  // TODO The dialog is sensitive to this.
            values: ["To do", "Done"],
            labels: {
                "To do": "To do",
                "Done": "Done"
            },
            visible: (element) => {
                const today = this.day(new Date().toISOString());

                if(this.state.statusFilter === 'To do') {
                    let plannedStart;
                    if(element.plannedStart instanceof Date) {
                        plannedStart = element.plannedStart.toISOString();
                    } else if(typeof element.plannedStart === 'string') {
                        plannedStart = element.plannedStart;
                    }

                    if(plannedStart && this.day(plannedStart) > today) {
                        return false;
                    }
                }

                if(this.state.mode === "do") {
                    if(this.onlyShowMyTasksInDoMode && !this.isAssignedTo(this.state.user, element.assigned)) {
                        return false;
                    }
                    if(this.hideDoneTasksInPlanMode && element.status === "Done" && (!element.updatedTime || this.day(element.updatedTime) < today)) {
                        return false;
                    }
                }

                return true;
            },
        },
    };
    states = {
        "Future": {
            // SegmentOutlinedIcon
            filterLabel: "Organize",
            value: "Done/In progress/To do/Future",
            status: "Future",
            label: "Later",
        },
        "To do": {
            filterLabel: "Plan",
            value: "In progress/To do",
            status: "To do",
            label: "To do",
            filterTasks: true,
            onlyShowActiveCategories: true,
            view: 'TodoLists',
        },
    };

    constructor(props) {
        super(props);
        console.log("Requirements:", props);

        this.styles = new StylesHappymade();

        this.select = this.select.bind(this);
        this.changeFilter = this.changeFilter.bind(this);
        this.changeFilter2 = this.changeFilter2.bind(this);
        this.newTask = this.newTask.bind(this);
        this.reload = this.reload.bind(this);
        this.remove = this.remove.bind(this);
        this.startMove = this.startMove.bind(this);
        this.endMove = this.endMove.bind(this);
        this.cancelNewRequirement = this.cancelNewRequirement.bind(this);
        this.setPastVisible = this.setPastVisible.bind(this);
        this.setFutureVisible = this.setFutureVisible.bind(this);
        this.setPlanMode = this.setPlanMode.bind(this);
        this.setDoMode = this.setDoMode.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
        this.closeDetails = this.closeDetails.bind(this);

        let mode = this.props.mode;
        if(["organize", "focus", "plan", "do"].indexOf(mode) < 0) {
            mode = "plan";
        }
        let statusFilter = (mode === "organize" ? "Future" : "To do");

        this.state = {
            product: {},
            user: undefined,
            users: [],
            errors: {},
            selection: undefined,
            version: new Date().getTime(),
            detailsVersion: new Date().getTime(),
            pastVisible: false,
            mode: mode,
            statusFilter: statusFilter,
            showStatus: false,
            dialogOpen: false,
            settingsOpen: false,
            move: false,
        };
    }

    // Copied from RequirementTree
    isAssignedTo(user, assigned) {
        if(!user) {
            // console.log("Requirements isAssignedTo: no user");
            return false;
        } else if(Array.isArray(assigned)) {
            var ret = false;
            assigned.forEach(a => {
                ret = ret || this.isAssignedTo(user, a);
            });
            // console.log("isAssignedTo array", assigned, ":", ret);
            return ret;
        } else if(assigned) {
            let ret = assigned.type === 'User' && assigned.id === user.id;
            // console.log("Requirements isAssignedTo", user, ", ", assigned, ":", ret);
            return ret;
        } else {
            // console.log("Requirements isAssignedTo null: false");
            return false;
        }
    }

    componentDidMount() {
        if(this.props.globals.authorized) {
            this.getProduct();
        }

        if(this.props.globals.authorized && this.props.user) {
            this.getUsers();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.globals.authorized && !prevProps.globals.authorized) {
            this.getProduct();
        }

        if(this.props.globals.authorized  && this.props.user && !(prevProps.globals.authorized && prevProps.user)) {
            this.getUsers();
        }
    }

    getProduct() {
        if(this.props.mock) {
            return;
        }

        // const request = `/model/Product/${this.props.product}`;
        const request = `/model`;
        return this.props.globals.get(request)
            .then(res => res.json())
            .then(
                (result) => {
                    console.log("Got model");
                    this.setState({
                        model: result,
                        products: result.products,
                    });

                    this.createInitialProduct(result, result.products, this.state.user);
                },
                (error) => {
                    console.error(error);
                }
            )
    }

    createInitialProduct(model, products, user) {
        if(model && user && !(products && products.length > 0)) {

            let values = {
                "name": user.name,
                "description": "",
                "access": user,
            };
            
            console.log("-> Create a product for", user, ":", values);

            this.props.globals.createChild(model, 'products', values)
                .then(res => res.json())
                .then(result => {
                        console.log("Product created:", result);
                        this.setState({
                            products: [result],
                        });
                        this.createInitialCategory(result, user);
                    },
                    error => {
                        console.error(error);
                    }
                );
        }
    }

    createInitialCategory(product, user) {
        let values = {
            "name": "Folder 1",
            "description": "",
            "members": user,
        };

        console.log("-> Create an initial category:", values);

        this.props.globals.createChild(product, 'categories', values)
            .then(res => res.json())
            .then(result => {
                    console.log("Category created:", result);
                    this.getProduct().then(() => this.reload());
                },
                error => {
                    console.error(error);
                }
            );
    }

    getUsers() {
        if(this.props.mock) {
            return;
        }

        // TODO users are returned in GET /model above too.
        console.log("Requirements.getUsers", this.props.user);
        this.props.globals.get(`/model/Model/1/users`)
            .then(res => res.json())
            .then(
                (result) => {
                    console.log('getUsers users:', result);
                    this.setState({
                        users: result,
                        userMap: this.buildElementMap(result),
                    });
                },
                (error) => {
                    console.error(error);
                }
            )

        this.props.globals.get(`/me`)
            .then(res => {
                if(!res.ok) {
                    console.error('get me error:', res);
                    this.setState({
                        errors: {
                            user: 'Not found'
                        },
                    });
                    return null;
                } else {
                    return res;
                }
            })
            .then(res => {
                return res ? res.json() : null
            })
            .then(result => {
                if(result) {
                    console.log('get me:', result);
                    this.setState({
                        user: result,
                    });

                    this.createInitialProduct(this.state.model, this.state.products, result);
                }
            })
    }

    buildElementMap(list) {
        let map = {};
        list.forEach( (item, i) => {
            map[item.type + '/' + item.id] = item;
        });
        return map;
    }

    select(object) {
        if(this.state.move) {
            if(object.type !== 'Requirement' && object.type !== 'Product' && object.type !== 'Category') {
                console.log("Requirements: cannot move to", object);
            } else if(object.type === this.state.move.type && object.id === this.state.move.id) {
                console.log("Requirements: cannot move to itself", object);
            } else {
                console.log("Requirements: move", this.state.move, "to", object);
                this.moveElement(this.state.move, object)
                this.setState({
                    selection: undefined,
                    move: undefined,
                });
            }
        } else {
            console.log("Requirements: select", object);
            this.setState({selection: object});
        }
    }

    cancelNewRequirement() {
        console.log("cancelNewRequirement");
        this.setState({
            newElement: null,
            newCard: null,
        });
    }

    newTask() {
        console.log("newTask");

        if(this.props.showTasksInTree) {
            this.setState({
                newElement: {
                    collection: "tasks",
                    values: {
                        type: "Task",
                        name: "New task",
                        status: "To do",
                    },
                }
            });
        } else {
            this.setState({
                dialogType: this.metamodel.task.name,
                dialogOpen: true
            });
        }
    }

    moveElement(element, newParent) {
        const request = "/model/" + element.type + "/" + element.id + "/parent/" + newParent.type + "/" + newParent.id;
        this.props.globals.put(request, {})
            .then(res => res.json())
            .then(
                (result) => {
                    console.log("Result", result);
                    this.reload(null);
                },
                (error) => {
                    console.error(error);
                }
            )
    }

    remove(element) {
        console.log("Requirements remove", element);

        this.props.globals.deleteElement(element).then(
            (result) => {
                console.log("Result", result);
                if(element === this.state.selection) {
                    this.setState({selection: null});
                }
                this.reload(null);
            },
            (error) => {
                console.error(error);
            }
        )
    }

    reload(parent) {
        // Reload all RequirementTrees.
        // TODO Only reload what actually changed.
        // FIXME At delete, this attempts to reload the deleted element too, causing an error response.
        this.setState({
            version: new Date().getTime()
        });
    }

    changeFilter(event) {
        console.log("changeFilter", event.target.value);
        this.setState({statusFilter: event.target.value});
    };

    changeFilter2(event, value) {
        console.log("changeFilter2", value);
        this.setState({statusFilter: value});
    };

    currentStatus() {
        console.log("currentStatus:", this.state.statusFilter);
        return this.states[this.state.statusFilter].status;
    }

    startMove(element) {
        console.log("Requirements.startMove", element);
        this.setState({move: element});
    }

    endMove() {
        console.log("Requirements.endMove");
        this.setState({
            move: undefined,
        });
    }

    render() {
        console.log("Requirements", this.state);
        let hasProducts = this.state.products && this.state.products.length > 0;
        let mode = this.state.mode;
        const statusFilter = this.state.statusFilter;
        console.log("Requirements hasProducts:", hasProducts, ", mode:", mode, ", statusFilter:", statusFilter);

        const user = this.state.user;
        const userId = user && user.id;
        const userFilter = userId; // (mode === "do" ? userId : null);
        const taskFilter = (mode === "do");
        console.log("Requirements: taskFilter:", taskFilter);

        // TODO Store futureVisible in the state instead of mode "plan" or "do"
        let futureVisible = (mode === "plan");
        // let showFuture = (mode === "do" &&
        //     <div className="showFuture">
        //         <IconButton aria-label="future" onClick={() => this.setFutureVisible(true)}>
        //             <ArrowDropDownOutlinedIcon />
        //         </IconButton>
        //     </div>);
        // let hideFuture = (mode === "plan" &&
        //     <div className="showFuture">
        //         <IconButton aria-label="future" onClick={() => this.setFutureVisible(false)}>
        //             <ArrowDropUpOutlinedIcon />
        //         </IconButton>
        //     </div>);

        return (
            <div className="App">
                <CssBaseline/>
                {!this.state.move &&
                <div className="top-bar">
                    <Chip
                        key="organize"
                        className="filter"
                        label="Overview"
                        variant={mode === "organize" && statusFilter === "Future" ? "default" : "outlined"}
                        onClick={() => {
                            this.setState({
                                mode: "organize",
                                statusFilter: "Future",
                            });
                            this.props.history.push("/organize");
                        }}
                    />
                    <Chip
                        key="focus"
                        className="filter"
                        label="Focus"
                        variant={mode === "focus" && statusFilter === "To do" ? "default" : "outlined"}
                        onClick={() => {
                            this.setState({
                                mode: "focus",
                                statusFilter: "To do",
                            });
                            this.props.history.push("/focus");
                        }}
                    />

                    {false &&
                        <Chip
                            key="plan"
                            className="filter"
                            label="Plan"
                            variant={mode === "plan" ? "default" : "outlined"}
                            onClick={this.setPlanMode}
                        />
                    }
                    {false &&
                        <Chip
                            key="do"
                            className="filter"
                            label="Do"
                            variant={mode === "do" ? "default" : "outlined"}
                            onClick={this.setDoMode}
                        />
                    }

                    <Chip
                        key="goals"
                        className="filter"
                        label="Goals"
                        variant={(mode === "plan" || mode === "do") ? "default" : "outlined"}
                        onClick={this.setDoMode}
                    />

                    {(mode === "plan" || mode === "do") &&
                    <AddIcon
                        key="add"
                        className="add"
                        onClick={() => {
                            let values = { ...this.metamodel.requirement.initialValues };
                            if(mode === "do") {
                                values.status = "To do";
                            }
                            this.setState({
                                newCard: {
                                    collection: "cards",
                                    values: values,
                                }
                            });
                        }}
                    />
                    }

                    {this.state.user &&
                    <AccountCircleOutlinedIcon
                        className="users"
                        onClick={(event) => {
                            this.setState({
                                anchorEl: event.currentTarget
                            });
                        }}/>
                    }
                    {this.state.errors.user &&
                    <ErrorOutlineOutlinedIcon
                        className="users"
                        onClick={(event) => {
                            this.setState({
                                anchorEl: event.currentTarget
                            });
                        }}/>
                    }
                    {!this.state.user && !this.state.errors.user &&
                    <RadioButtonUncheckedOutlinedIcon
                        className="users"
                        onClick={(event) => {
                            this.setState({
                                anchorEl: event.currentTarget
                            });
                        }}/>
                    }

                    <Menu
                        id="user-menu"
                        anchorEl={this.state.anchorEl}
                        getContentAnchorEl={null}
                        PaperProps={{
                            style: {
                                transform: this.state.user ? 'translateX(-45px) translateY(32px)' : 'translateX(-100px) translateY(32px)',
                            }
                        }}
                        MenuListProps={{
                            style: {
                                padding: 0,
                            },
                        }}
                        open={Boolean(this.state.anchorEl)}
                        onClose={this.closeMenu}
                    >
                        {this.state.user &&
                        <MenuItem onClick={() => {
                            this.closeMenu();
                            this.setState({settingsOpen: true});
                        }}>
                            Settings
                        </MenuItem>
                        }
                        <AmplifySignOut/>
                    </Menu>
                </div>
                }
                {this.state.move &&
                <div className="top-bar top-bar-modal">
                    Move element. Select a new parent.
                    <Button className="top-bar-button" variant="contained" onClick={this.endMove}>
                        Cancel
                    </Button>
                </div>
                }

                {!hasProducts &&
                    <div>Initializing...</div>
                }

                {hasProducts && (mode === "organize" || mode === "focus") &&
                    <div className="main">
                    <div className="tree">
                        <RequirementTree
                            globals={this.props.globals}
                            metamodel={this.metamodel}
                            showTasks={this.props.showTasksInTree}
                            styles={this.styles}
                            // TODO Support 0 or multiple Products
                            element={this.state.products[0]}
                            version={this.state.version}
                            selection={this.state.selection}
                            showStatus={this.state.showStatus}
                            statusFilter={this.states[statusFilter]}
                            userFilter={userFilter}
                            user={this.state.user}
                            onSelect={this.select}
                            move={this.state.move}
                        />
                    </div>
                    {this.state.selection && !this.state.move &&
                    <div className="details">
                        <RequirementDetails
                            globals={this.props.globals}
                            showTasks={!this.props.showTasksInTree}
                            showStatus={true}
                            metamodel={this.metamodel}
                            states={this.states}
                            styles={this.styles}
                            user={user}
                            users={this.state.users}
                            userMap={this.state.userMap}
                            element={this.state.selection}
                            filter={{status: statusFilter, user: userFilter, openTasks: taskFilter}}
                            version={this.state.detailsVersion}
                            remove={this.remove}
                            newTask={this.newTask}
                            onRequirementUpdate={() => {
                                this.reload(null);
                            }}
                            onStartMove={this.startMove}
                            onEndMove={this.endMove}
                            onClose={this.closeDetails}
                        />
                        {this.state.selection && (this.state.selection.categories || this.state.selection.cards) &&
                        <div className="buttons-below">
                            {/* AddBoxOutlineIcon */}
                            {this.state.selection.categories &&
                            <Button
                                variant="contained"
                                className="new"
                                onClick={() => {
                                    this.setState({
                                        newElement: {
                                            collection: "categories",
                                            values: {
                                                type: "Category",
                                                name: "New folder",
                                            },
                                        }
                                    });
                                }}
                            >
                                New folder
                            </Button>
                            }
                            {/* AddIcon */}
                            {this.state.selection.cards &&
                            <Button
                                variant="contained"
                                className="new"
                                onClick={() => {
                                    this.setState({
                                        newElement: {
                                            collection: "cards",
                                            values: { ...this.metamodel.requirement.initialValues },
                                        }
                                    });
                                }}
                            >
                                New card
                            </Button>
                            }
                        </div>
                        }
                    </div>
                    }
                    {this.state.newElement &&
                    <div className="details details-create">
                        <RequirementDetails
                            globals={this.props.globals}
                            metamodel={this.metamodel}
                            showStatus={true}
                            states={this.states}
                            styles={this.styles}
                            users={this.state.users}
                            userMap={this.state.userMap}
                            parent={this.state.selection}
                            collection={this.state.newElement.collection}
                            element={this.state.newElement.values}
                            onChildAdded={() => {
                                this.setState({newElement: null});
                                this.reload(null);
                            }}
                            create="true"
                            onCancel={this.cancelNewRequirement}
                        />
                    </div>
                    }
                </div>
                }

                {hasProducts && user && (mode === "plan" ||mode === "do") &&
                    <div key="todolists">
                        <TodoLists key="todolists1"
                            globals={this.props.globals}
                            metamodel={this.metamodel}
                            // TODO Support 0 or multiple Products
                            element={this.state.products[0]}
                            user={user}
                            users={this.state.users}
                            userMap={this.state.userMap}
                            filter={{
                                status: statusFilter,
                                user: userFilter,
                                openTasks: taskFilter,
                                onlyShowMyTasksInDoMode: this.onlyShowMyTasksInDoMode,
                            }}
                            newElement={this.state.newCard}
                            remove={this.remove}
                            onChildAdded={() => {
                                this.setState({newCard: null});
                                // this.reload(null);
                            }}
                            cancelNewRequirement={this.cancelNewRequirement}
                            pastVisible={this.state.pastVisible}
                            setPastVisible={this.setPastVisible}
                            futureVisible={futureVisible}
                            setFutureVisible={this.setFutureVisible}
                            styles={this.styles}
                        />
                    </div>
                }

                <UserSettingsDialog
                    user={user}
                    open={this.state.settingsOpen}
                    onClose={() => this.setState({settingsOpen: false})}
                    globals={this.props.globals}
                />
            </div>
        );
    }

    setPastVisible(visible) {
        // TODO Store this in the history
        this.setState({pastVisible: visible});
    }

    setFutureVisible(visible) {
        // TODO Change how this is represented in the state:
        // - One property toggles between Folders and Goals
        // - One property shows or hides past cards
        // - One property shows or hides future cards
        this.setState({
            mode: visible ? "plan" : "do",
            statusFilter: "To do",
        });

        this.props.history.push(visible ? "/plan" : "/do");
    }

    // TODO Use setFutureVisible instead
    setPlanMode() {
        this.setState({
            mode: "plan",
            statusFilter: "To do",
        });
        this.props.history.push("/plan");
    }

    // TODO Use setFutureVisible instead
    setDoMode() {
        this.setState({
            mode: "do",
            statusFilter: "To do",
        });
        this.props.history.push("/do");
    }

    closeMenu() {
        this.setState({anchorEl: null});
    }

    closeDetails() {
        this.setState({selection: null});
    }

    day(date) {
        return date.split('T')[0];
    }
}

export default withRouter(Requirements);
